import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 px-6 mt-auto">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        
        {/* Brand */}
        <div>
            <h2 className="text-2xl font-extrabold text-yellow-400 mb-4">KaamSetu 🇮🇳</h2>
            <p className="text-slate-400 text-sm">
                Connecting India's hardworking hands with those who need them. Trusted, Transparent, and Free.
            </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col gap-2">
            <h3 className="font-bold text-lg mb-2 text-white">Quick Links</h3>
            <Link to="/" className="text-slate-400 hover:text-white transition">🔍 Find Workers</Link>
            <Link to="/add-worker" className="text-slate-400 hover:text-white transition">👷 Join as Worker</Link>
            <Link to="/about" className="text-slate-400 hover:text-white transition">ℹ️ About Us</Link>
            <Link to="/contact" className="text-slate-400 hover:text-white transition">📞 Contact Support</Link>
        </div>

        {/* Legal */}
        <div className="flex flex-col gap-2">
            <h3 className="font-bold text-lg mb-2 text-white">Legal</h3>
            <Link to="/privacy-policy" className="text-slate-400 hover:text-white transition">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white transition">Terms & Conditions</Link>
        </div>

      </div>

      <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-500 text-sm">
        &copy; {new Date().getFullYear()} KaamSetu. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;